<script setup lang="ts">
import type { Props as PropsBtn } from './ButtonAction.vue'

type Props = Omit<PropsBtn, 'icon'> & { icon?: 'left' | true }
const props = defineProps<Props>()
const left = computed(() => props.icon === 'left')
const init3 = useInited('init3')
</script>

<template>
  <ButtonAction v-bind="props" :icon="left ? true : 'right'" :aria-label="left ? 'Previous' : 'Next'" :class="[left ? $style.l : $style.r]" class="IconArrow">
    <span class="_svg16">
      <LazyIconChevronArr v-if="init3" :left :class="!props.disabled && $style.a" class="_svg16" />
    </span>
  </ButtonAction>
</template>

<style module>
.a {
  transition: transform 200ms var(--tran3);
  transform: translate3d(0, 0, 0);
  transform-origin: center center;
}
.r:hover .a,
.r:focus-visible .a {
  transform: translate3d(5px, 0, 0) scale(1.5);
}
.l:hover .a,
.l:focus-visible .a {
  transform: translate3d(-5px, 0, 0) scale(1.5);
}
.r:active:hover .a {
  transform: translate3d(10px, 0, 0) scale(1.5);
}
.l:active:hover .a {
  transform: translate3d(-10px, 0, 0) scale(1.5);
}
</style>
